import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=65253889&"
import script from "./Values.vue?vue&type=script&lang=js&"
export * from "./Values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports